import { FC } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";

type AddressTypeSelectProps = {
  handleAddressTypeChange: any;
  selectedAddressType: any;
  addressTypes: any;
  disabled?: boolean;
};

const AddressTypeSelect: FC<AddressTypeSelectProps> = ({
  addressTypes,
  selectedAddressType,
  handleAddressTypeChange,
  disabled = false,
}) => {
  return (
    <Autocomplete
      id="addressType"
      options={addressTypes || []}
      getOptionLabel={(option) => intl.get(option.label)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      disabled={disabled}
      value={
        addressTypes && selectedAddressType != null
          ? addressTypes.find(
              (addressType) => addressType.id === selectedAddressType
            )
          : null
      }
      onChange={(event, newValue) => handleAddressTypeChange(newValue)}
      loading={addressTypes == null}
      renderInput={(params) => (
        <TextField
          {...params}
          label={intl.get("addressForm.placeholder.addressType")}
          disabled={disabled}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {addressTypes == null ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default AddressTypeSelect;
